import { render, staticRenderFns } from "./installationRecord.vue?vue&type=template&id=422b1843&scoped=true"
import script from "./installationRecord.vue?vue&type=script&lang=js"
export * from "./installationRecord.vue?vue&type=script&lang=js"
import style0 from "./installationRecord.vue?vue&type=style&index=0&id=422b1843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b1843",
  null
  
)

export default component.exports